
import apiURL from './apiURL';
// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
  ORGANISATION_GET: "ORGANISATION_GET",
  ORGANISATION_LOADING: "ORGANISATION_LOADING",
};

const loadingOrganisation = (id) => ({
  type: Types.ORGANISATION_LOADING,
});

const organisationUpdate = response => ({
  type: Types.ORGANISATION_GET,
  payload: response
});

const getOrganisationDetails = () => {
  return (dispatch, getState) => {
      dispatch(loadingOrganisation())

    fetch(apiURL + `/settings/businessDetails` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('organisationData',data)
      dispatch(organisationUpdate(data))
    })
  }
}

// const costCentersSaved = response => ({
//   type: Types.COSTCENTER_SAVE,
//   payload: response
// });

// const saveCostCenters = () => {
//   return (dispatch, getState) => {

//     const state = getState()

//     const costCenters = state.costCenter.costCenterList

//     console.log('costCenters',costCenters)

//     fetch(apiURL + `/settings/costCenters` , {
//         credentials: 'include',
//         method: 'POST',
//         body: JSON.stringify({costCenters}),
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//           /*'Organisation': getState().currentOrganisation,*/
//         },
//     })
//     .then(response => response.json())
//     .then(data => {
//       console.log('entity data',data)
//       dispatch(costCentersSaved(data))
//     })
//   }
// }

const Actions = {
  getOrganisationDetails
}

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions